import * as React from "react";
/**
 * This icon from MDL2 is not available in @fluentui/react-icons
 * So we have to create the react icon component ourselves
 */ export const FormsLogoFilled = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#clip0_998_31900)"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M3.75 10V18.75C3.75 19.375 4.375 20 5 20H18.75C19.5 20 20 19.5 20 18.75V10L12.5 7.5L3.75 10Z",
        fill: "#036C70"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M20 10V1.25C20 0.5 19.5 0 18.75 0H5C4.25 0 3.75 0.5 3.75 1.25V10H20Z",
        fill: "#37C6D0"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M17.5 12.5H12.5V17.5H17.5V12.5Z",
        fill: "#1A9BA1"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M15 8.75C17.0711 8.75 18.75 7.07107 18.75 5C18.75 2.92893 17.0711 1.25 15 1.25C12.9289 1.25 11.25 2.92893 11.25 5C11.25 7.07107 12.9289 8.75 15 8.75Z",
        fill: "#1A9BA1"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M15 7.5C16.3807 7.5 17.5 6.38071 17.5 5C17.5 3.61929 16.3807 2.5 15 2.5C13.6193 2.5 12.5 3.61929 12.5 5C12.5 6.38071 13.6193 7.5 15 7.5Z",
        fill: "#036C70"
    }), /*#__PURE__*/ React.createElement("path", {
        opacity: "0.5",
        d: "M12.5 5H3.75V17.5H11.25C12.625 17.5 13.75 16.375 13.75 15V6.25C13.75 5.625 13.25 5 12.5 5Z",
        fill: "black"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M11.25 16.25H1.25C0.5 16.25 0 15.75 0 15V5C0 4.375 0.5 3.75 1.25 3.75H11.25C12 3.75 12.5 4.375 12.5 5V15C12.5 15.75 12 16.25 11.25 16.25Z",
        fill: "#038387"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M8.875 7.5H5.625V9.5H8.625V10.75H5.625V13.75H4.125V6.25H8.875V7.5Z",
        fill: "white"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "clip0_998_31900"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: "20",
        height: "20",
        fill: "white"
    }))));
